// src/components/PublicLicense.js
import React from 'react';
import License from './License';

function PublicLicense() {
  return <License />;
}

export default PublicLicense;